export const FAQS = [
  {
    q: "Can you manage my Hyderabad property while I live in the USA?",
    a: "Yes. Managing properties for owners living abroad is exactly what we are built for. Whether you are in the USA, UK, Canada, Australia, UAE, Singapore, Europe or anywhere else, we act as your local presence in Hyderabad — coordinating tenants, rent, inspections, maintenance and documentation on your behalf, with clear photo/video reporting.",
  },
  {
    q: "Do you manage only rental properties?",
    a: "No. We assist with vacant, owner-occupied and rental properties depending on the service you need. If your property is vacant, we can inspect it periodically, keep it maintained and prepare it for tenants or for your own visit.",
  },
  {
    q: "Do you collect rent?",
    a: "Yes. Rent collection assistance can be provided as part of the agreed scope. We track due dates, remind tenants when required, maintain payment records and keep you informed every month.",
  },
  {
    q: "Can you help find tenants?",
    a: "Yes. We assist with property photographs, listing preparation, handling enquiries, shortlisting and tenant coordination through to move-in.",
  },
  {
    q: "Do you verify tenants?",
    a: "We coordinate tenant verification and background-check processes as applicable, including employment/reference checks where relevant and police/tenant verification assistance.",
  },
  {
    q: "Can you handle rental agreements?",
    a: "We coordinate rental agreement preparation and registration through appropriate service providers, and manage renewals when the term ends.",
  },
  {
    q: "Can you inspect my property?",
    a: "Yes. We carry out initial, periodic, move-in, move-out, pre-rental, post-vacancy, damage, leakage, electrical and general condition inspections — documented with photographs, videos where applicable, issues identified and recommended actions.",
  },
  {
    q: "Will I receive photographs?",
    a: "Yes. Where inspection or reporting is included in your scope, you receive photographs and videos so you can see the actual condition of your property — not just hear about it.",
  },
  {
    q: "Can you handle plumbing and electrical problems?",
    a: "Yes. We coordinate plumbers and electricians for leakages, taps, flush systems, water lines, drainage, pumps, switches, sockets, lights, fans, MCB issues and minor electrical repairs.",
  },
  {
    q: "Can you arrange painting?",
    a: "Yes. Full painting, touch-up painting, wall repair and repainting after a tenant vacates — coordinated with vendors, supervised on site and reported back with photos.",
  },
  {
    q: "Can you clean the property after a tenant vacates?",
    a: "Yes. We arrange move-out cleaning, deep cleaning, bathroom and kitchen cleaning and full make-ready preparation before the next tenant moves in.",
  },
  {
    q: "Can you prepare the property for the next tenant?",
    a: "Yes. Our make-ready process covers inspection, condition reporting, cleaning, pest control, plumbing, electrical, painting, carpentry and final presentation — then we assist with re-rental.",
  },
  {
    q: "Can you handle complete interior work?",
    a: "Yes. Larger interior and renovation projects — design, modular furniture, false ceiling, flooring, complete execution — are coordinated separately through the group's professional execution network.",
  },
  {
    q: "Do you charge a fixed monthly fee?",
    a: "Not necessarily. Pricing depends on your property, the rent value and the services you need. Every property is different, so we prepare a customized proposal after understanding your requirements.",
  },
  {
    q: "Can you handle everything for me?",
    a: "Our objective is end-to-end property support. However, certain legal, tax, banking and regulatory matters may require coordination with your authorized professionals — such as your CA or bank — and we will coordinate with them where required.",
  },
  {
    q: "Which areas do you serve?",
    a: "We currently serve Hyderabad and Greater Hyderabad only. We are deliberately launching in one city so we can maintain the service standard our owners expect.",
  },
];
